import { ArrowLeftIcon } from "@/lib/icons"
import { useNavigate } from "@/lib/router"
import { Routes } from "@/constants/routes"
import { useTrans } from "@/lib/i18n"

interface BackIconProps {
	href: Routes
}
export const BackIcon = ({ href }: BackIconProps) => {
	const t = useTrans()
	const navigate = useNavigate()
	return (
		<a
			href={href}
			data-testid="back-icon"
			aria-label={t("common:navigation.back")}
			className="inline-flex min-h-[44px] min-w-[44px] items-center justify-center focus:underline"
			onClick={(e) => {
				e.preventDefault()
				void navigate(href)
			}}
		>
			<ArrowLeftIcon
				aria-hidden="true"
				className="size-6 shrink-0 text-gray-400 hover:text-gray-700"
			/>
		</a>
	)
}
